<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBackgroundBlurLight_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <g clip-path="url(#IconBackgroundBlurLight_24__a)">
        <g clip-path="url(#IconBackgroundBlurLight_24__b)">
            <circle cx="3.5" cy="3.75" r=".5" fill="currentColor" />
            <circle cx="7.625" cy="3.75" r=".75" fill="currentColor" />
            <circle cx="12" cy="3.75" r=".75" fill="currentColor" />
            <circle cx="16.375" cy="3.75" r=".75" fill="currentColor" />
            <g filter="url(#IconBackgroundBlurLight_24__c)">
                <circle cx="20.5" cy="3.75" r=".5" fill="currentColor" />
            </g>
            <circle cx="8" cy="16" r="1" fill="currentColor" />
            <path
                fill="currentColor"
                d="M12 12a2.4 2.4 0 0 1-1.766-.734A2.4 2.4 0 0 1 9.5 9.5q0-1.03.734-1.766A2.4 2.4 0 0 1 12 7q1.032 0 1.766.734.734.735.734 1.766t-.734 1.766T12 12m-3.75 5q-.516 0-.883-.367A1.2 1.2 0 0 1 7 15.75v-.5q0-.531.274-.977.273-.444.726-.68a9.3 9.3 0 0 1 1.969-.726 8.6 8.6 0 0 1 4.062 0 9.3 9.3 0 0 1 1.969.727q.453.234.726.68.274.444.274.976v.5q0 .516-.367.883-.368.367-.883.367z"
            />
            <circle cx="3.5" cy="20.25" r=".5" fill="currentColor" />
            <circle cx="7.625" cy="20.25" r=".75" fill="currentColor" />
            <circle cx="12" cy="20.25" r=".75" fill="currentColor" />
            <circle cx="16.375" cy="20.25" r=".75" fill="currentColor" />
            <circle cx="20.5" cy="20.25" r=".5" fill="currentColor" />
            <circle
                cx="20.25"
                cy="7.75"
                r=".75"
                fill="currentColor"
                transform="rotate(90 20.25 7.75)"
            />
            <circle
                cx="20.25"
                cy="11.75"
                r=".75"
                fill="currentColor"
                transform="rotate(90 20.25 11.75)"
            />
            <circle
                cx="3.75"
                cy="7.75"
                r=".75"
                fill="currentColor"
                transform="rotate(90 3.75 7.75)"
            />
            <circle
                cx="3.75"
                cy="11.75"
                r=".75"
                fill="currentColor"
                transform="rotate(90 3.75 11.75)"
            />
            <circle
                cx="20.25"
                cy="15.75"
                r=".75"
                fill="currentColor"
                transform="rotate(90 20.25 15.75)"
            />
            <circle
                cx="3.75"
                cy="15.75"
                r=".75"
                fill="currentColor"
                transform="rotate(90 3.75 15.75)"
            />
        </g>
        <circle cx=".5" cy="12" r=".5" fill="currentColor" />
        <circle cx="12" cy=".5" r=".5" fill="currentColor" />
        <circle cx="12" cy="23.5" r=".5" fill="currentColor" />
        <circle cx="23.5" cy="12" r=".5" fill="currentColor" />
    </g>
    <defs>
        <clipPath id="IconBackgroundBlurLight_24__a">
            <path fill="currentColor" d="M0 0h24v24H0z" />
        </clipPath>
        <clipPath id="IconBackgroundBlurLight_24__b">
            <path fill="currentColor" d="M3 3h18v18H3z" />
        </clipPath>
        <filter
            id="IconBackgroundBlurLight_24__c"
            width="9"
            height="9"
            x="16"
            y="3.25"
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6106_341"
            />
            <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_6106_341"
                result="shape"
            />
        </filter>
    </defs>
</svg>
